/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import ReactHtmlParser from 'react-html-parser';
import { uid } from 'react-uid';
import { useAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import PassportLanderCta from './PassportLanderCta';
import resolvePassportCopy from './resolvePassportCopy';

const useStyles = makeStyles(() => ({
    section: { background: '#329A77', color: '#fff', textAlign: 'center', padding: '46px 24px 58px' },
    heading: { maxWidth: 1320, margin: '0 auto 27px', fontFamily: 'Fields, Georgia, serif', fontSize: 24, lineHeight: 1.2, whiteSpace: 'nowrap', '@media (max-width: 1100px)': { whiteSpace: 'normal' }, '@media (max-width: 600px)': { fontSize: 22 } },
    image: { display: 'block', width: '100%', maxWidth: 740, margin: '0 auto' },
    divider: { width: '70%', height: 0, color: 'inherit', background: 'transparent', opacity: 1, border: 0, borderTop: '2px solid currentColor', margin: '34px auto 35px' },
    copy: { maxWidth: 560, margin: '0 auto', fontSize: 23, lineHeight: 1.2, fontWeight: 700, '& h1': { fontSize: 68 }, '& h2': { fontSize: 40 }, '& h3': { fontSize: 30 }, '& p': { margin: 0 }, '@media (max-width: 760px)': { fontSize: 17.25, '& h1': { fontSize: 51 }, '& h2': { fontSize: 30 }, '& h3': { fontSize: 22.5 } } },
    ctaHeading: { margin: '0 auto 27px', fontSize: 23, fontWeight: 700, '& p': { margin: 0 }, '@media (max-width: 760px)': { fontSize: 17.25 } },
    signIn: { margin: '24px auto 0', fontSize: 20, fontWeight: 700 },
    signInButton: { padding: 0, border: 0, background: 'transparent', color: 'inherit', textDecoration: 'underline', font: 'inherit', cursor: 'pointer' },
}));

const PassportLanderBrands = ({ data, skus, cartIconLabel, enrolledCopy, styling }) => {
    const classes = useStyles();
    const { loginByRedirect } = useAuth();
    const desktop = data?.participating_brands_group_image_desktop;
    const mobile = data?.participating_brands_group_image_mobile || desktop;
    const copyBlocks = (data?.copy_block || []).map((block) => resolvePassportCopy(block, skus)).filter(Boolean);
    const renewal = resolvePassportCopy(data?.cta?.cta_heading, skus);
    return (
        <section
            className={classes.section}
            data-component="passportLanderBrands"
            style={{ backgroundColor: styling?.merchanding_background_color || data?.background_color || '#329A77', color: styling?.merchandising_font_color || '#fff' }}
        >
            <h2 className={classes.heading}>{data?.heading}</h2>
            <picture>
                {mobile?.url && <source media="(max-width: 600px)" srcSet={mobile.url} />}
                <img className={classes.image} src={desktop?.url} alt="Participating Celebrations brands" />
            </picture>
            {copyBlocks.length > 0 && <hr className={classes.divider} />}
            {copyBlocks.map((block, index) => (
                <React.Fragment key={uid(block, index)}>
                    <div className={classes.copy}>{ReactHtmlParser(block)}</div>
                    <hr className={classes.divider} />
                </React.Fragment>
            ))}
            {renewal && <div className={classes.ctaHeading}>{ReactHtmlParser(renewal)}</div>}
            {data?.cta && <PassportLanderCta skus={skus} cta={data.cta} cartIconLabel={cartIconLabel} styling={styling} />}
            {enrolledCopy && <p className={classes.signIn}>{enrolledCopy} <button className={classes.signInButton} type="button" onClick={() => loginByRedirect()}>Sign in</button></p>}
        </section>
    );
};
PassportLanderBrands.propTypes = { data: object.isRequired, skus: object, cartIconLabel: string, enrolledCopy: string, styling: object };
PassportLanderBrands.defaultProps = { skus: {}, cartIconLabel: 'Cart', enrolledCopy: 'Already a member?', styling: {} };
export default PassportLanderBrands;
